import React from 'react';
import { History } from 'lucide-react';
import { PurchaseOrder } from '../../../../../types/PurchaseOrder.types';
import { DetailCard } from '../../../../../components/shared/DetailPanel/DetailBlocks';
import { PurchaseOrderStatusBadge } from './PurchaseOrderStatusBadge';
import { formatDateTime } from './format';

// Historial de estados de la OC. El trigger de BD escribe una fila por cada
// cambio, incluida la de creación ("draft"), así que no hace falta sintetizar
// nada: se pinta tal cual llega de purchase_orders_get.
export const StatusTimeline = ({ order }: { order: PurchaseOrder }) => (
  <DetailCard icon={History} title="Historial_De_Estados">
    {order.statusHistory.length === 0 ? (
      <div className="purchases-view__empty-block">Sin cambios de estado registrados</div>
    ) : (
      <ol className="purchases-view__timeline">
        {order.statusHistory.map(entry => (
          <li key={entry.id} className={`purchases-view__timeline-item ${entry.status}`}>
            <span className="purchases-view__timeline-dot" />
            <div className="purchases-view__timeline-body">
              <div className="purchases-view__timeline-head">
                <PurchaseOrderStatusBadge status={entry.status} />
                <span className="purchases-view__timeline-date">{formatDateTime(entry.changedAt)}</span>
              </div>
              <div className="purchases-view__timeline-who">
                {entry.changedByName || (entry.changedBy ? `Usuario #${entry.changedBy}` : 'Sistema')}
              </div>
              {entry.note && <div className="purchases-view__timeline-note">{entry.note}</div>}
            </div>
          </li>
        ))}
      </ol>
    )}
  </DetailCard>
);
